export default __webpack_public_path__ + "static/media/background.142c582d.png";